import showToast from "./toast";

// errorHandler.js
export const handleApiError = (error) => {
  

  if (error?.code==="ERR_NETWORK") {
    showToast({ message: "Network error", type: "error" });
    return;
  }

  const { status, data } = error?.response;

  if (data?.message) {
    showToast({ message: data?.message, type: "error" });
  } else if (status === 400) {
    showToast({
      message: "Bad request. Please check your input.",
      type: "error",
    });
  } else if (status === 401) {
    showToast({
      message: "Unauthorized access. Please log in.",
      type: "error",
    });
  } else if (status === 403) {
    showToast({
      message: "Forbidden. You don't have permission.",
      type: "error",
    });
  } else if (status === 404) {
    showToast({ message: "Resource not found.", type: "error" });
  } else if (status === 408) {
    showToast({ message: "Request timeout. Please try again.", type: "error" });
  } else if (status === 429) {
    showToast({
      message: "Too many requests. Please slow down.",
      type: "error",
    });
  } else if (status >= 500) {
    showToast({ message: "Server error. Please try later.", type: "error" });
  } else {
    showToast({ message: "Something Went Wrong!", type: "error" });
  }
};
